"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _get = _interopRequireDefault(require("lodash/get"));

var _pull = _interopRequireDefault(require("lodash/pull"));

var _FollowCard = _interopRequireDefault(require("./FollowCard"));

var _state = require("../utils/state");

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FollowList = /*#__PURE__*/function (_Component) {
  _inherits(FollowList, _Component);

  var _super = _createSuper(FollowList);

  function FollowList() {
    var _this;

    _classCallCheck(this, FollowList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_handleFollow", function (_ref) {
      var organizerId = _ref.organizerId,
          organizers = _ref.organizers;

      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          callback = _ref2.callback;

      if (_this.props.isHiddenWhenFollowed) {
        var newOrganizerList = (0, _pull.default)(organizers, organizerId);

        if (_this.props.onEmpty && newOrganizerList.length === 0) {
          _this.props.onEmpty();
        }
      }

      _this.props.onFollow(organizerId, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleUnFollow", function (_ref3) {
      var organizerId = _ref3.organizerId;

      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          callback = _ref4.callback;

      _this.props.onUnFollow(organizerId, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleOnViewOrganizer", function (organizerId) {
      _this.props.onViewOrganizer(organizerId);
    });

    _defineProperty(_assertThisInitialized(_this), "_handleClose", function (organizerId, organizers) {
      var newOrganizerList = (0, _pull.default)(organizers, organizerId);

      if (_this.props.onClose) {
        _this.props.onClose(organizerId, newOrganizerList);
      }

      if (_this.props.onEmpty && newOrganizerList.length === 0) {
        _this.props.onEmpty();
      }

      if (_this.props.onRemoveOrganizer) {
        _this.props.onRemoveOrganizer(organizerId);
      }
    });

    return _this;
  }

  _createClass(FollowList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          style = _this$props.style,
          size = _this$props.size,
          isClosable = _this$props.isClosable,
          isHiddenWhenFollowed = _this$props.isHiddenWhenFollowed,
          shouldHideDefaultDataPoint = _this$props.shouldHideDefaultDataPoint,
          organizers = _this$props.organizers,
          organizerData = _this$props.organizerData;

      var _cleanOrganizerData = (0, _state.cleanOrganizerData)(organizers, organizerData, isHiddenWhenFollowed),
          prunedOrganizers = _cleanOrganizerData.organizers,
          prunedOrganizerData = _cleanOrganizerData.organizerData;

      var followList = /*#__PURE__*/_react.default.createElement("div", null);

      if (prunedOrganizers.length) {
        followList = /*#__PURE__*/_react.default.createElement("ul", {
          className: "follow-list follow-list--".concat(style, " mobile-card-carousel")
        }, prunedOrganizers.map(function (organizerId) {
          return /*#__PURE__*/_react.default.createElement("li", {
            key: organizerId,
            className: "follow-list__item"
          }, /*#__PURE__*/_react.default.createElement(_FollowCard.default, {
            style: style,
            size: size,
            isClosable: isClosable,
            organizerId: organizerId,
            onFollow: _this2._handleFollow.bind(null, {
              organizerId: organizerId,
              organizers: prunedOrganizers
            }),
            onUnFollow: _this2._handleUnFollow.bind(null, {
              organizerId: organizerId
            }),
            onClose: _this2._handleClose.bind(null, organizerId, prunedOrganizers),
            onViewOrganizer: _this2._handleOnViewOrganizer.bind(null, organizerId),
            isFollowing: (0, _get.default)(prunedOrganizerData, [organizerId, 'followedByYou'], null),
            organizerName: (0, _get.default)(prunedOrganizerData, [organizerId, 'name'], ''),
            organizerProfileUrl: (0, _get.default)(prunedOrganizerData, [organizerId, 'url'], ''),
            numUpcomingEvents: (0, _get.default)(prunedOrganizerData, [organizerId, 'numUpcomingEvents'], null),
            numFollowers: (0, _get.default)(prunedOrganizerData, [organizerId, 'numFollowers'], null),
            imageUrl: (0, _get.default)(prunedOrganizerData, [organizerId, 'profilePicture'], ''),
            customDataPoint: (0, _get.default)(prunedOrganizerData, [organizerId, 'customDataPoint'], ''),
            isHiddenWhenFollowed: isHiddenWhenFollowed,
            shouldHideDefaultDataPoint: shouldHideDefaultDataPoint
          }));
        }));
      }

      return /*#__PURE__*/_react.default.createElement("div", null, followList);
    }
  }]);

  return FollowList;
}(_react.Component);

exports.default = FollowList;

_defineProperty(FollowList, "propTypes", {
  /**
   * Ids of the organizers we will render
   */
  organizers: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,

  /**
   * Data about the organizers
   */
  organizerData: _propTypes.default.objectOf(_propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    name: _propTypes.default.string,
    url: _propTypes.default.string,
    followedByYou: _propTypes.default.bool,
    profilePicture: _propTypes.default.string,
    numUpcomingEvents: _propTypes.default.number,
    numFollowers: _propTypes.default.number,
    customDataPoint: _propTypes.default.string
  })),

  /*
   * Style of list to be rendered 'grid' or 'list'
   */
  style: _propTypes.default.oneOf(_constants.FOLLOW_LIST_STYLES).isRequired,

  /*
   * Size of cards to render: 'mini' or 'standard'
   */
  size: _propTypes.default.oneOf(_constants.CARD_SIZES).isRequired,

  /*
   * Callback for when user clicks to follow
   */
  onFollow: _propTypes.default.func.isRequired,

  /*
   * Callback for when user clicks to unfollow
   */
  onUnFollow: _propTypes.default.func.isRequired,

  /*
   * Callback for when user closes an organizer
   */
  onRemoveOrganizer: _propTypes.default.func,

  /*
   * Callback for when user views an organizer
   */
  onViewOrganizer: _propTypes.default.func,

  /*
   * Callback for when close button is clicked
   */
  onClose: _propTypes.default.func,

  /*
   * Callback for when no organizers are left to follow
   */
  onEmpty: _propTypes.default.func,

  /*
   * Boolean if 'X' button appears on cards
   */
  isClosable: _propTypes.default.bool,

  /*
   * Boolean determining if cards should animate
   * "out" when follow occurs.
   */
  isHiddenWhenFollowed: _propTypes.default.bool,

  /*
   * If true, it won't show the default message whenever the
   * other data points are not available. This is false by default.
   */
  shouldHideDefaultDataPoint: _propTypes.default.bool
});

_defineProperty(FollowList, "defaultProps", {
  isHiddenWhenFollowed: false,
  shouldHideDefaultDataPoint: false,
  isClosable: false
});
//# sourceMappingURL=FollowList.js.map